import { DetailedError } from '@library/utils'
import type { FC } from 'react'

export const WillThrow: FC = () => {
  throw new DetailedError('Not found', { code: 404 })
}
